import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

// Design colours for the deal-card status tags (--green / --amber in the design file).
const GREEN = '#1EAD5C';
const AMBER = '#E8A83C';
const CORAL = '#FC7785';
const BLUE = '#4A67FF';

const VCHeroSection = () => (
    <section className="lp-hero lp-hero--vc">
        <div className="lp-hero-glow" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                <div className="lp-badge" data-lp-reveal><span />For VC firms</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">Impact on your portfolio returns if we could help you avoid the worst two investments in every ten?</h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">Free application triaging in 3–4 minutes. Free early investment readiness assessments. Diligence pack before IC, not after. Portfolio companies always ready for follow-on rounds or exit. Qualified, prediligenced deal flow meeting your investment criteria.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <a className="lp-btn lp-btn--primary" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a 30-min call</a>
                    <a className="lp-btn lp-btn--pe-outline" href="#try-the-demo">See how it works ↓</a>
                </div>
                <div className="lp-hero-social" data-lp-reveal data-lp-delay="240">Free to VC firms · No IT setup · 40+ VCs already on platform</div>
            </div>

            <div className="lp-hero-art">
                <div className="lp-hero-stage lp-hero-stage--vc">
                    <img className="lp-hero-photo" src={require('../../../../images/landing-pages/VC/vc-top-banner.png')} alt="VC partner" />
                    <div className="lp-vc-dealcard" data-lp-reveal data-lp-delay="200">
                        <div className="dc-top">
                            <span className="t">360° Deal View</span>
                            <span className="live">Live</span>
                        </div>
                        <div className="dc-label" style={{ color: CORAL }}>Your 180°</div>
                        <div className="dc-row">
                            <span className="lbl">Pitch deck quality</span>
                            <span className="val" style={{ color: GREEN }}>✓ Strong</span>
                        </div>
                        <div className="dc-divider" />
                        <div className="dc-label" style={{ color: BLUE }}>The other 180° — Diligentsia</div>
                        <div className="dc-row">
                            <span className="lbl">Automated diligence pack</span>
                            <span className="val" style={{ color: AMBER }}>⚠ 2 gaps</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default VCHeroSection;
